import React from "react";
import { ProgressDots, Spinner } from "@optimizely/axiom";
import { useDecision } from "@optimizely/react-sdk";
import { Flags } from "../../../feature-flags/flags";
import { ANONYMOUS_USER_ID } from "../../../constants/constants";
import classnames from "classnames";

const REBRAND_LOGO_WIDTH = 240;

type LoadingIndicatorProps = {
    height?: string;
    overlay?: boolean;
    type?: "dots" | "spinner";
    logo?: boolean;
    width?: string;
};

export const LoadingIndicator = ({
    height = "100vh",
    overlay = false,
    type = "dots",
    logo = false,
    width: passedWidth = undefined
}: LoadingIndicatorProps) => {
    const [rebrandDecision, clientReady] = useDecision(Flags.ENABLE_REBRAND, { autoUpdate: true });
    const userId = rebrandDecision.userContext?.id;
    const hasRealUser =
        clientReady && typeof userId === "string" && userId.trim() !== "" && userId !== ANONYMOUS_USER_ID;
    const rebrand = rebrandDecision.enabled && hasRealUser;
    const logoSrc = rebrand ? "/logo-new.svg" : "/logo.png";
    const position = overlay ? "absolute" : undefined;
    const width = overlay ? "100%" : passedWidth;
    const background = overlay ? "rgba(255, 255, 255, 0.75)" : undefined;
    const top = overlay ? "0" : undefined;
    const left = overlay ? "0" : undefined;
    const classes = classnames("flex flex--column flex-align--center flex-justified--center", {
        "admin-center__loading--rebrand": rebrand
    });

    return (
        <div
            className={classes}
            role="alert"
            aria-busy="true"
            style={{ height, width, position, background, top, left }}
        >
            {logo && hasRealUser && (
                <img alt="Optimizely" src={logoSrc} width={rebrand ? REBRAND_LOGO_WIDTH : undefined} />
            )}
            {type === "dots" && <ProgressDots />}
            {type === "spinner" && <Spinner />}
        </div>
    );
};

LoadingIndicator.displayName = "LoadingIndicator";
